"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../../constants");
/**
 * Returns the first valid email from string.
 * Used to get email from Acsel
 *
 * @param emailList - The email list getting from Acsel
 */
function getFirstValidEmail(emailList) {
    // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
    var emailArray = emailList.match(constants_1.emailRegex);
    if (emailArray) {
        return emailArray[0];
    }
    return '';
}
exports.default = getFirstValidEmail;
//# sourceMappingURL=getFirstValidEmail.js.map